import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface CloseTicketModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (comment: string) => void;
  isSubmitting: boolean;
}

const CloseTicketModal: React.FC<CloseTicketModalProps> = ({ show, onHide, onSubmit, isSubmitting }) => {
  const [comment, setComment] = useState('');

  const handleSubmit = () => {
    if (comment.trim()) {
      onSubmit(comment);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Close Ticket</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Please provide a reason for closing this ticket. This will be added as a comment.</p>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Enter your comment..."
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!comment.trim() || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit and Close'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CloseTicketModal;
